import { HttpClient, HttpClientFactory, NoAuthAuthenticator } from '../httpClient'
import { getOrganizationInvite } from './endpoints/getOrganizationInvite'
import { getOrganizationPublic } from './endpoints/getOrganizationPublic.ts'
import { IInviteAction, updateOrganizationInvite } from './endpoints/updateOrganizationInvite.ts'

export interface INextpeakPublicClientOpts {
	baseUrl: string
}

export class NextpeakPublicClient {
	readonly client: HttpClient

	constructor(
		private readonly opts: INextpeakPublicClientOpts,
		httpClientFactory: HttpClientFactory
	) {
		this.client = httpClientFactory.createClient(this.opts.baseUrl, {
			clientName: this.constructor.name,
			defaultAuthenticator: new NoAuthAuthenticator(),
		})
	}

	async getOrganizationInvite(inviteId: string) {
		return getOrganizationInvite(this.client, inviteId)
	}

	async updateOrganizationInvite(inviteId: string, inviteAction: IInviteAction) {
		return updateOrganizationInvite(this.client, inviteId, inviteAction)
	}

	async getOrganizationPublic(organizationId: string) {
		return getOrganizationPublic(this.client, organizationId)
	}
}
